import { render, staticRenderFns } from "./pointsExchangeOrder.vue?vue&type=template&id=2e4c969a&scoped=true"
import script from "./pointsExchangeOrder.vue?vue&type=script&lang=js"
export * from "./pointsExchangeOrder.vue?vue&type=script&lang=js"
import style0 from "./pointsExchangeOrder.vue?vue&type=style&index=0&id=2e4c969a&prod&lang=less&scoped=true"
import style1 from "./pointsExchangeOrder.vue?vue&type=style&index=1&id=2e4c969a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4c969a",
  null
  
)

export default component.exports